if (customElements.get('affiliate-form') === undefined) {
  class AffiliateForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.submit = this.querySelector('[type="submit"]');
      this.password = this.querySelector('[name="password"]');
      this.passwordConfirmation = this.querySelector('[name="password_confirmation"]');
      this.switches = this.querySelectorAll('[data-visible]');
      this.errorWrapper = this.querySelector('[data-error]');
      this.errorText = this.querySelector('[data-error-text]');
      this.successWrapper = this.querySelector('[data-success]');
      this.closeModalButton = this.querySelector('[data-close-modal]');

      this.switches.forEach((switcher) => {
        switcher.addEventListener('click', () => {
          this.switchVisibility(switcher);
        });
      });

      this.form.addEventListener('submit', (e) => {
        this.formSubmit(e);
      });

      this.closeModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSuccessModal();
      });
    }

    formSubmit(e) {
      e.preventDefault();
      this.errorWrapper.classList.add('hidden');
      this.successWrapper.classList.add('hidden');

      this.errorText.innerHTML = '';
      const errors = this.checkValidation();

      if (!errors.length) {
        this.formFetch();
      } else {
        this.errorWrapper.classList.remove('hidden');
        let errorsList = '<ul>';

        errors.forEach((error) => {
          errorsList += `<li>${error}</li>`;
        });
        errorsList += '</ul>';
        this.errorText.insertAdjacentHTML('afterbegin', errorsList);
      }
    }

    formFetch() {
      const formData = new FormData(this.form);
      console.log(this.form.getAttribute('action'));
      fetch(this.form.getAttribute('action'), {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.text())
        .then(() => {
          this.successWrapper.classList.remove('hidden');
        });
    }

    closeSuccessModal() {
      this.successWrapper.classList.add('hidden');
    }

    checkValidation() {
      const errors = [];
      if (this.password.value.trim() !== this.passwordConfirmation.value.trim()) {
        errors.push('The password confirmation does not match.');
      }

      if (this.password.value.trim().length < 6) {
        errors.push('The password must be at least 6 characters.');
      }
      console.log(errors);
      return errors;
    }

    showError(text) {
      this.errorWrapper.classList.toggle('hidden');
      this.errorText.innerHTML = text;
    }

    switchVisibility(switcher) {
      const label = switcher.closest('label');
      const input = label.querySelector('input');
      const visibility = switcher.dataset.visible;
      let swither2;

      if (visibility === 'true') {
        input.setAttribute('type', 'password');
        swither2 = label.querySelector(`[data-visible="false"]`);
      } else {
        input.setAttribute('type', 'text');
        swither2 = label.querySelector(`[data-visible="true"]`);
      }

      switcher.classList.toggle('hidden');
      swither2.classList.toggle('hidden');
    }
  }

  customElements.define('affiliate-form', AffiliateForm);
}
